import React, { Component } from 'react';
import { Container, Row, Col, Button, Input, InputGroupAddon, InputGroup, InputGroupText } from 'reactstrap';
/* eslint react/no-unescaped-entities:0 */
class Page401 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <div className="clearfix">
                <h1 className="float-left display-3 mr-4">401</h1>
                <h4 className="pt-3">Oops! You're lost.</h4>
                <p className="text-muted float-left">You havent permission to access this page</p>
              </div>
              <InputGroup className="input-prepend">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input size="16" type="text" placeholder="What are you looking for?" />
                <InputGroupAddon addonType="append">
                  <Button color="info">Search</Button>
                </InputGroupAddon>
              </InputGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page401;



// WEBPACK FOOTER //
// ./src/views/Pages/Page401/Page401.js